import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col, Button, Form, Card, Breadcrumb, Accordion } from 'react-bootstrap';
import Select from 'react-select';
import { fetchVehicleById, fetchVehiclesAll, fetchVehiclesAllByOwnerId, fetchVehiclesAllResearchAvailable } from '../../actions/request/VehicleRequest';
import { fetchReservationTypesAll } from '../../actions/request/ReservationTypeRequest';
import { fetchCustomersAll } from '../../actions/request/CustomerRequest';
import { toast } from 'react-toastify';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { MdOutlineAirlineSeatReclineNormal, MdOutlineLocationOn, MdSend, } from 'react-icons/md';
import { fetchCodePostalsAll } from '../../actions/request/CodePostalRequest';
import { ROUTES } from '../../config/routingUrl';
import { fetchPropertyById, fetchPropertysAll, fetchPropertysAllByOwnerId, fetchPropertysAllResearchAvailable } from '../../actions/request/PropertyRequest';
import { FETCH_PROPERTY_SUCCESS, FETCH_VEHICLE_SUCCESS } from '../../app/actions/actions';
import { handleImageUploadCloud } from '../../actions/upload/UploadFileCloud';
import PropertyDetails from '../../components/web/patrimoine/PropertyDetails';
import VehicleDetails from '../../components/web/patrimoine/VehicleDetails';
import axios from 'axios';
import { baseurl } from '../../utils/url/baseurl';
import { currentDate, emptyImage, logoApplication } from '../../utils/dataApi/dataFormApi';
import CarInfoDetail from '../../components/web/cardetail/CarInfoDetail';
import NotFoundComponent from '../../components/web/patrimoine/NotFoundComponent';
import { FaArrowAltCircleRight } from 'react-icons/fa';
import { IoSpeedometerOutline } from 'react-icons/io5';
import { TbManualGearbox } from 'react-icons/tb';
import { FaChargingStation } from 'react-icons/fa6';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const CardDetailPage = () => {

    const navigate = useNavigate();
    const paramVehicle = useParams();
    const dispatch = useDispatch();
    const vehicle = useSelector((state) => state.vehicles.vehicle);
    const property = useSelector((state) => state.propertys.property);
    const vehicles = useSelector((state) => state.vehicles.vehiclesAvailable);
    const propertys = useSelector((state) => state.propertys.propertysAvailable);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 1200 },
            items: 4,
        },
        desktop: {
            breakpoint: { max: 1200, min: 992 },
            items: 4,
        },
        tablet: {
            breakpoint: { max: 992, min: 768 },
            items: 2,
        },
        mobile: {
            breakpoint: { max: 768, min: 0 },
            items: 1,
        },
    };


    useEffect(() => {
        // dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: {} })
        // dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: {} })
        dispatch(fetchVehicleById(paramVehicle?.id || ""));
        dispatch(fetchPropertyById(paramVehicle?.id || ""));
        // dispatch(fetchReservationTypesAll());
        // dispatch(fetchCustomersAll());
        dispatch(fetchCodePostalsAll());
        dispatch(fetchVehiclesAllResearchAvailable(currentDate, currentDate));
        dispatch(fetchPropertysAllResearchAvailable(currentDate, currentDate));

    }, [dispatch, paramVehicle]);

    // useEffect(() => {
    //     dispatch(fetchVehiclesAllByOwnerId(vehicle?.addBy));
    //     dispatch(fetchPropertysAllByOwnerId(vehicle?.addBy));
    // }, [dispatch, paramVehicle])







    const [filteredVehicles, setFilteredVehicles] = useState([]);
    const [filteredProperties, setFilteredProperties] = useState([]);
    // État pour gérer le survol de chaque élément
    const [hoverStates, setHoverStates] = useState({});

    // Fonction pour mettre à jour l'état de survol d'un élément spécifique
    const handleMouseEnter = (id) => {
        setHoverStates((prevState) => ({
            ...prevState,
            [id]: true,
        }));
    };

    const handleMouseLeave = (id) => {
        setHoverStates((prevState) => ({
            ...prevState,
            [id]: false,
        }));
    };


    useEffect(() => {
        // Filtrage basé sur le prix
        const vehiclesFiltered = vehicles || []
        const propertiesFiltered = propertys || []
        setFilteredVehicles(vehiclesFiltered);
        setFilteredProperties(propertiesFiltered);
    }, [vehicles, propertys]);



    const currentItems = (vehicle && vehicle._id)
        ? filteredVehicles
        : filteredProperties;









    return (
        <div className=""  >


            {
                property && property._id && (<PropertyDetails property={property} />)
            }


            {
                vehicle && vehicle._id && (<VehicleDetails vehicle={vehicle} />)
            }



            {
                (!vehicle?._id && !property?._id) && (
                    <NotFoundComponent />
                )
            }

            <div className="container-fluid" style={{ padding: "10px 0px 2px 0px", background: "#F5FDF7" }}>
                {
                    currentItems && currentItems.length > 0 && (
                        <div className="container">
                            {
                                vehicle && vehicle?._id ?
                                    (<h3 style={{ color: "#737373" }} className="py-2">Autres véhicules populaires</h3>)
                                    :
                                    property && property?._id ? (<h3 style={{ color: "#737373" }} className="py-2">Autres Prorpiétés populaires</h3>)
                                        : ""
                            }
                        </div>
                    )
                }
                <div className="container">
                    {currentItems.length > 0 && currentItems.filter((item) => item.isVisible == true).length > 0 && (
                        <Carousel responsive={responsive} autoPlay={true} infinite={true} transitionDuration={8}    >
                            {currentItems.length > 0 && currentItems.filter((item) => item.isVisible == true).length > 0 ? (
                                currentItems.filter((item) => item.isVisible == true).map((item) => {
                                    // État unique pour chaque élément
                                    const isHovered = hoverStates[item._id]; // Vérifie si l'élément actuel est survolé
                                    return (
                                        <div
                                            onMouseEnter={() => handleMouseEnter(item._id)} // Déclenche lorsqu'on survole
                                            onMouseLeave={() => handleMouseLeave(item._id)} // Déclenche lorsque la souris quitte
                                            className="p-2"
                                        >
                                            <div className="" style={{ width: "100%" }}>
                                                <div className="shadow-sm rounded-lg" style={{ margin: "10px", width: "100%", overflow: "hidden", }}>

                                                    <div style={{
                                                        height: "200px",
                                                        background: "#F2F2F2", width: "100%",
                                                        borderBottomLeftRadius: isHovered ? "20px" : "0px",
                                                        borderBottomRightRadius: isHovered ? "20px" : "0px",
                                                    }}>
                                                        {
                                                            item && item.images && item.images.length > 0 ?
                                                                <img src={item.images[0]} style={{
                                                                    height: "200px", width: "100%",
                                                                    transition: "transform 0.3s ease-in-out",
                                                                    transform: isHovered ? "scale(1.1)" : "scale(1)", // Zoom léger sur l'image
                                                                }} />
                                                                :
                                                                <img src={emptyImage} style={{
                                                                    height: "200px", width: "100%",
                                                                    transition: "transform 0.3s ease-in-out",
                                                                    transform: isHovered ? "scale(1.1)" : "scale(1)", // Zoom léger sur l'image
                                                                }} />
                                                        }
                                                    </div>
                                                    <div style={{ background: "white", padding: "10px", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px" }}>
                                                        <div><h6 className="text-dark">{item.brand || item.name}</h6></div>
                                                        <div className="pt-2 pb-2" style={{ display: "flex", justifyContent: "space-between", }}>
                                                            <div>
                                                                <span style={{ fontWeight: "bold", fontSize: "25px" }} className="font-bold text-dark"> {item.basePricePerDay || 0} </span>
                                                                <span style={{ fontWeight: "bold", fontSize: "12px" }} className="text-dark">DZD</span>
                                                                <span style={{ color: "#A6A6A6", fontSize: "12px" }}>/Jour</span>
                                                            </div>
                                                            <div>
                                                                {/*<span style={{ color: "#A6A6A6", fontSize: "12px" }}> <MdLocationOn /> Algerie</span> */}
                                                            </div>
                                                        </div>
                                                        {// vehicle
                                                            item?.brand && (item?.mileage || item?.options?.automaticTransmission || item?.passenger || item?.engineType?.name) && (
                                                                <div style={{ padding: "5px 5px 5px 5px", display: "flex", justifyContent: "space-between", background: "#F6F6F6" }} className="my-3 rounded-lg">
                                                                    {// kilometrage
                                                                        item?.mileage && (
                                                                            <div className="rounded-lg bg-grey p-2" style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                                                                <IoSpeedometerOutline className="text-dark" size={25} />
                                                                                <span className="text-dark">{item?.mileage || 0}</span>
                                                                            </div>
                                                                        )
                                                                    }
                                                                    {// transmition
                                                                        (item?.options?.automaticTransmission || item?.options?.manualTransmission) && (
                                                                            <div className="rounded-lg bg-grey p-2" style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                                                                <TbManualGearbox className="text-dark" size={25} />
                                                                                <span className="text-dark">
                                                                                    {item?.options?.automaticTransmission ? "Auto" :
                                                                                        item?.options?.manualTransmission ? "Manuelle" : ""}
                                                                                </span>
                                                                            </div>
                                                                        )
                                                                    }
                                                                    {// Sièges
                                                                        item?.passenger && (
                                                                            <div className="rounded-lg bg-grey p-2" style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                                                                <MdOutlineAirlineSeatReclineNormal className="text-dark" size={25} />
                                                                                <span className="text-dark">{item?.passenger || 4}</span>
                                                                            </div>
                                                                        )
                                                                    }

                                                                    {//moteur
                                                                        item?.engineType && item?.engineType?.name && (
                                                                            <div className="rounded-lg bg-grey p-2" style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                                                                <FaChargingStation className="text-dark" size={25} />
                                                                                <span className="text-dark">{item?.engineType?.name || ""}</span>
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                            )
                                                        }

                                                        {// property
                                                            item?.name && (
                                                                <div style={{ padding: "5px 5px 5px 5px", display: "flex", justifyContent: "space-between", background: "#F6F6F6" }} className="my-3 rounded-lg">

                                                                    <div className="rounded-lg bg-grey p-2" style={{ display: "flex", justifyContent: "center", flexDirection: "row" }}>
                                                                        <MdOutlineLocationOn className="text-dark" size={25} />
                                                                        <span className="text-dark">{item.address}</span>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }

                                                        <div>
                                                            <Button type="button"
                                                                onClick={() => {
                                                                    if (item?.color) {
                                                                        dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: item });
                                                                        dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: {} });
                                                                        navigate(`/${ROUTES.CAR_DETAIL_VIEW}/${item._id}/name/${item.brand}/description/${item.brand}`);
                                                                    } else {
                                                                        dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: {} });
                                                                        dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: item });
                                                                        navigate(`/${ROUTES.CAR_DETAIL_VIEW}/${item._id}/name/${item.name}/description/${item.name}`);
                                                                    }
                                                                }}
                                                                style={{
                                                                    padding: "10px 5px 10px 5px", borderRadius: "30px", textAlign: "center", display: "flex", justifyContent: "center"
                                                                    , borderRadius: "30px",
                                                                    textAlign: "center",
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    transition: "all 0.3s ease-in-out", // Animation fluide
                                                                }}
                                                                variant={isHovered ? "dark" : "outline-dark"} // Change le variant du bouton
                                                                className={`w-100 ${isHovered ? "text-white" : "text-dark"} border-dark`}>
                                                                <div style={{ display: "flex", width: "100%", flexDirection: "row", justifyContent: isHovered ? "space-between" : "center", alignContent: "center" }}>

                                                                    <div className={`${isHovered ? "px-3 font-fold" : "p-1"}`}>
                                                                        <span className="text-center "> Voir l{"'"}offre </span>
                                                                    </div>
                                                                    {
                                                                        isHovered && (
                                                                            <div className={`${isHovered ? "px-3 font-fold" : "p-1"}`} style={{ transition: "all 0.3s ease-in-out" }}>
                                                                                <FaArrowAltCircleRight size={25} className="text-primary" />
                                                                            </div>
                                                                        )
                                                                    }

                                                                </div>
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            ) : (
                                <Col md={12}></Col>
                            )}
                        </Carousel>
                    )}
                </div>
            </div>

        </div>
    );
};

export default CardDetailPage;




